export interface ImageFile {
  fileName: string;
  // Базовое изображение (base@jpg) — просмотр и «скачать»
  url: string;
  // Уменьшенная копия (thumb@webp) для карточки списка; null у файлов, ещё не переработанных под imgproxy
  thumbnailUrl?: string | null;
}

export interface FundraiserImagesModel {
  avatar: ImageFile;
  mainImages: ImageFile[];
  feedImages: ImageFile[];
}
export enum ImageType {
  MAIN = 'main',
  FEED = 'feed',
  AVATAR = 'avatar',
  STORY_SCREEN = 'story_screen',
  STORY_PREVIEW = 'story_preview',
}
